import { render } from "./HorseDiets.vue?vue&type=template&id=a791b650"
import script from "./HorseDiets.vue?vue&type=script&lang=js"
export * from "./HorseDiets.vue?vue&type=script&lang=js"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__